import { Button, Flex, Text } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React from "react"
import { useTranslation } from "react-i18next"

interface Props {
  selectedImageIds: EntityId[]
  isImportingImages: boolean
  hasSelectedImages: boolean
  handleUploadImages: () => void
  closeCloudProviderModal: () => void
}

const CloudImageBrowserActionsDesktop: React.FC<Props> = ({
  selectedImageIds,
  closeCloudProviderModal,
  handleUploadImages,
  hasSelectedImages,
  isImportingImages,
}) => {
  const { t } = useTranslation()

  return (
    <Flex
      flex={1}
      pr={4}
      py={4}
      justifyContent="space-between"
      alignItems="center"
    >
      <Text>
        {t(
          "components.cloudProvider.common.browser.CloudImageBrowserActionsDesktop.Selected",
          { count: selectedImageIds.length }
        )}
      </Text>
      <Flex gap={4}>
        <Button
          className="google-photos-close-modal-button"
          variant="outline"
          isDisabled={isImportingImages}
          onClick={closeCloudProviderModal}
        >
          {t(
            `components.cloudProvider.common.browser.CloudImageBrowserActionsDesktop.Cancel`
          )}
        </Button>
        <Button
          className="google-photos-import-images-button"
          colorScheme="primary"
          onClick={handleUploadImages}
          isLoading={isImportingImages}
          isDisabled={!hasSelectedImages}
        >
          {t(
            `components.cloudProvider.common.browser.CloudImageBrowserActionsDesktop.Import`
          )}
        </Button>
      </Flex>
    </Flex>
  )
}

export default CloudImageBrowserActionsDesktop
